import { Component, computed, inject, effect, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Permissions } from '@anessa/shared-models';
import { provideI18nScope } from '../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../shared/i18n/i18n-scoped.service';
import { I18nPipe } from '../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../shared/i18n/i18n-scope-ready.directive';
import { CustomViewsService } from '../custom-views/services/custom-views.service';
import { PermissionService } from '../../shared/services/permissions/permission.service';
import { CustomViewsUiService } from '../../ui/custom-view/custom-views-ui.service';
import { EmptyStateCard } from '../../shared/common/empty-state-card/empty-state-card';

@Component({
  selector: 'app-custom-views-landing',
  imports: [
    I18nPipe,
    I18nScopeReadyDirective,
    MatButtonModule,
    MatIconModule,
    EmptyStateCard,
  ],
  templateUrl: './custom-views-landing.html',
  styleUrl: './custom-views-landing.scss',
  providers: [provideI18nScope('features/custom-views-landing'), I18nScopedService],
})
export class CustomViewsLanding {
  private readonly customViewsService = inject(CustomViewsService);
  private readonly router = inject(Router);
  private readonly permissionService = inject(PermissionService);
  private readonly customViewsUi = inject(CustomViewsUiService);

  readonly loading = signal(true);
  views = this.customViewsService.viewList;

  // Same gate as the sidebar popout's "+".
  readonly canEdit = computed(() =>
    this.permissionService.hasPermission(Permissions.EDIT_CUSTOM_VIEWS),
  );

  constructor() {
    effect(() => {
      const loaded = this.customViewsService.viewListLoaded();
      if (!loaded) return;

      this.loading.set(false);

      const list = this.customViewsService.viewList();
      if (list.length > 0) {
        void this.router.navigateByUrl('/custom-views/' + list[0].id);
      }
    });
  }

  createView(): void {
    this.customViewsUi.openAddViewDialog();
  }
}
